import bags from "./bags.jpg";
import iman from "./iman.jpg";
import iwomen from "./iwomen.jpg";
import jack from "./jack.jpg";
import lady from "./lady.jpg";
import men from "./men.jpg";

export const homeImages = [
  {
    id: 1,
    image: iman,
  },
  {
    id: 2,
    image: iwomen,
  },
  {
    id: 3,
    image: jack,
  },
  {
    id: 4,
    image: lady,
  },
  {
    id: 5,
    image: men,
  },
  {
    id: 6,
    image: bags,
  },
];
